// extracted by mini-css-extract-plugin
module.exports = {"artworkDetails":"ArtworkCardDetails_artworkDetails__0D5Yu","artworkImageContent":"ArtworkCardDetails_artworkImageContent__LFoo2","details":"ArtworkCardDetails_details__CIjTi"};